import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useCountDown } from 'ahooks';
import moment from 'moment';
import dynamic from 'next/dynamic';

import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { getProductMsg, getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import SEOlinksA from '@/components/SEOlinksA';
import ProductNav from '@/components/ProductCommon/ProductNav';
import { useLang } from '@/i18n';
import { useSupportData } from '@/utils/hooks';
import { LAUNCHTIME, LOCALE_ARR } from '@/constants/singleAxis';

const launchTime = moment(LAUNCHTIME).toString();

const PageConPc: any = dynamic(() => import('@/components/productSmart/singleAxis'), { ssr: true });
const PageConH5: any = dynamic(() => import('@/componentsH5/productSmart/singleAxis'), { ssr: true });
const ProductSpecs: any = dynamic(() => import('@/components/ProductCommon/ProductSpecs'), { ssr: true });
const ProductSupport: any = dynamic(() => import('@/components/ProductCommon/ProductSupport'), { ssr: false });

// TODO: 产品详情页参数
const productName = 'single-axis-solar-tracker';
const generalKey = 'product_mh100';

export default function SingleAxisSolarTracker({ SEO, lang }: any) {
    const { t } = useLang('singleaxissolartracker');

    const { isMobile, gloproductlist } = useGlobal();
    const { locale, query } = useRouter();
    const supportStr = query?.support || '';

    const [showPage, setShowPage] = useState(false);
    const [_countdown] = useCountDown({ targetDate: launchTime });
    const [tabName, setTabName] = useState<string>('Overview');
    const isShowSupport = supportStr === '1'; //是否默认显示support

    const SingleAxisSolarTracker = isMobile ? PageConH5 : PageConPc;
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg);

    useEffect(() => {
        const envArr = ['test', 'dev'];
        const isProd = !envArr.includes(process.env.NEXT_PUBLIC_MODY);

        if (isProd && _countdown <= 0) {
            // 生产环境已到发布时间
            setShowPage(true);
        }

        if (!isProd) {
            setShowPage(true);
        }
    }, []);
    // 切换tab
    const tabState = (val: any) => {
        setTabName(val);
        const target1 = document.querySelector('.product-tab.show-tab') as HTMLDivElement;
        const target2 = document.querySelector(`.product-tab-${val}`) as HTMLDivElement;
        if (target1) target1?.classList.remove('show-tab');
        if (target2) target2?.classList.add('show-tab');
    };

    useEffect(() => {
        if (isShowSupport) {
            const target2 = document.querySelector(`.detail-nav li:nth-child(3)`) as HTMLDivElement;
            target2 && target2.click();
        }
    }, [isShowSupport]);

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={LOCALE_ARR} locale={locale} pathname="single-axis-solar-tracker" />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} light product_common product_common_real product_common_0426`} theme="black">
                <ProductNav
                    className="wbg"
                    title={productMsg?.name}
                    theme="black"
                    buyLink={productMsg?.buyLink || ''}
                    callback={tabState}
                    productKey={generalKey}
                />
                <div className={`product-tab product-tab-Overview${tabName === 'Overview' ? ' show-tab' : ''}`}>
                    {!!showPage ? <SingleAxisSolarTracker /> : null}
                </div>
                <div className="product-tab product-tab-Specs">
                    {tabName === 'Specs' && (
                        <>
                            <ProductSpecs theme="black" productDetail={productDetail} resProductCatagory={resProductCatagory} />
                            <div className="product-specs-tips">{t('detail.product_specs_tips')}</div>
                        </>
                    )}
                </div>
                <div className={`product-tab product-tab-Support${tabName === 'Support' ? ' show-tab' : ''}`}>
                    {tabName === 'Support' && <ProductSupport theme="black" supportData={supportData} />}
                </div>
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale }: any) {
    const whiteLocaleList = LOCALE_ARR;
    if (!whiteLocaleList.includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
